// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"875b4c85","551":"de0b8b3d"}[chunkId] + ".chunk.js";
};